import React from 'react';
import { StatusKeys } from '../../query';
import useDocumentTitle from 'Shared/hooks/useDocumentTitle';
import withErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import pathToUrl from 'Shared/util/pathToUrl';
import useQueryParamsFilter from 'Shared/hooks/useQueryParamsFilter';

import Dashboard from '../../components/Dashboard';
import ProjectsTable from '../../components/ProjectsTable';
import getIdIfExist from 'Shared/util/getIdIfExist';

const TabProjects = ({ match: { path, params } }) => {
  useDocumentTitle('Projects - List');

  const filterQueryParams = (query) => {
    if (query.company) query.company = getIdIfExist(query.company);

    return query;
  };

  const [projectsFilter, setProjectsFilter, meta] = useQueryParamsFilter({
    term: '',
    company: null,
    status: StatusKeys.PROGRESS,
  }, {
    filter: filterQueryParams,
  });

  const handleChange = (data) => {
    setProjectsFilter(prevFilter => ({
      ...prevFilter,
      ...data,
    }));
  };

  const handleTabChange = (status) => {
    setProjectsFilter(prevFilter => ({
      ...prevFilter,
      company: null,
      term: '',
      status,
    }));
  };

  return (
    <div className="projects__main">
      <div className="projects__table-container">
        <Dashboard
          onTermChange={handleChange}
          onTabChange={handleTabChange}
          mainUrl={pathToUrl(path, params)}
          currentStatus={projectsFilter?.status}
          searchInputValue={projectsFilter?.term}
        />
        <ProjectsTable
          filterMeta={meta}
          projectsFilter={projectsFilter}
          onFilterChange={handleChange}
        />
      </div>
    </div>
  );
};

export default withErrorBoundary(TabProjects);
